// Terms.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto mt-10 bg-white shadow-sm rounded-lg p-6 text-gray-800">
          <h1 className="text-3xl md:text-4xl font-bold text-red-700 mb-6">Общи условия за ползване на услугите на EvoCard</h1>
          <p className="leading-relaxed mb-4">
            Настоящите Общи условия (наричани по-долу „Условия“ или „Общи условия“) уреждат отношенията между Вас (наричани по-долу „Потребител“, „Клиент“ или „Вие“) и EvoCard (наричана по-долу „Доставчик“, „ние“, „нашите“, „EvoCard“). С достъпа до или използването на услугите на EvoCard (включително уебсайтове, мобилни приложения, физически продукти и свързани услуги) Вие потвърждавате, че сте прочели, разбрали и се съгласявате да спазвате настоящите Условия.
          </p>
          {/* 1. Описание на услугите */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              1. Описание на услугите
            </h2>
            <p className="leading-relaxed mb-4">
              1.1. EvoCard предоставя физически поздравителни карти (наричани „Карта“), към които е прикрепен дигитален компонент (уникален идентификатор, баркод, парола и др.) с цел да се качват и възпроизвеждат персонализирани видеопослания или друго мултимедийно съдържание (наричано „Съдържание“).
            </p>
            <p className="leading-relaxed mb-4">
              1.2. Услугите на EvoCard може да включват:
            </p>
            <ul className="list-disc list-inside pl-4 space-y-2">
              <li>
                Уеб базирана платформа и/или мобилно приложение за качване и управление на Съдържанието;
              </li>
              <li>Съхранение на Съдържанието в облачна услуга;</li>
              <li>Възможност за споделяне, изтегляне или изтриване на качено Съдържание;</li>
              <li>Други допълнителни функционалности.</li>
            </ul>
          </div>
          {/* 2. Регистрация и достъп */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              2. Регистрация и достъп
            </h2>
            <p className="leading-relaxed mb-4">
              2.1. За да използвате пълноценно услугите на EvoCard, е възможно да е необходима регистрация в нашата система или изтегляне на мобилното приложение. Вие поемате отговорност за верността и пълнотата на подадените от Вас данни.
            </p>
            <p className="leading-relaxed mb-4">
              2.2. Достъпът до Съдържанието, качено чрез определена карта, обикновено се осъществява чрез сканиране на баркод/QR код и въвеждане на парола. Потребителят е отговорен да съхранява тези данни (парола, код) поверително и да не ги предоставя на трети лица без право на достъп.
            </p>
          </div>
          {/* 3. Качване на съдържание */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              3. Качване на съдържание
            </h2>
            <p className="leading-relaxed mb-4">
              3.1. Вие може да качвате Съдържание (видеоклипове) свързано с конкретна EvoCard. С качването на Съдържание, Вие потвърждавате, че притежавате или имате необходимите права за използване на това Съдържание.
            </p>
            <p className="leading-relaxed mb-4">
              3.2. Забранява се качването на Съдържание, което:
            </p>
            <ul className="list-disc list-inside pl-4 space-y-2">
              <li>Нарушава действащото законодателство и/или права на трети лица;</li>
              <li>Съдържа обидни, неприлични, дискриминационни, насърчаващи насилие или незаконни дейности материали;</li>
              <li>
                Всякакъв друг материал, който е в противоречие с нормите на морала и добрите нрави или с политиката на EvoCard.
              </li>
            </ul>
            <p className="leading-relaxed mb-4 mt-4">
              3.3. EvoCard си запазва правото да премахне или ограничи достъпа до Съдържание, за което има основания да се смята, че нарушава настоящите Условия или действащото законодателство.
            </p>
          </div>
          {/* 4. Поверителност и защита на данните */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              4. Поверителност и защита на данните
            </h2>
            <p className="leading-relaxed mb-4">
              4.1. EvoCard събира и обработва лични данни в съответствие с действащото законодателство в областта на защитата на личните данни и съгласно нашата Политика за поверителност, която е неразделна част от настоящите Условия.
            </p>
            <p className="leading-relaxed mb-4">
              4.2. Вие носите отговорност да осигурите съгласие от трети лица, чиито лични данни или образ могат да бъдат включени във Вашите видеоклипове или друго Съдържание, качено чрез услугите на EvoCard.
            </p>
          </div>
          {/* 5. Изтриване на съдържанието */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              5. Изтриване на съдържанието
            </h2>
            <p className="leading-relaxed mb-4">
              5.1. Потребителите, които имат валидна парола и идентификатор за дадена карта, могат да изтрият каченото Съдържание в облачната услуга по всяко време, при условие че имат необходимите права за това.
            </p>
            <p className="leading-relaxed mb-4">
              5.2. При изтриване на Съдържанието, EvoCard може да запази резервно копие за определен период, ако това е необходимо за изпълнение на законови задължения или за техническа сигурност.
            </p>
          </div>
          {/* 6. Интелектуална собственост */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              6. Интелектуална собственост
            </h2>
            <p className="leading-relaxed mb-4">
              6.1. Всички търговски марки, лога, търговски наименования, дизайни, софтуерни решения и други обекти на интелектуална собственост, свързани с EvoCard, са собственост на Доставчика или на неговите лицензодатели и са защитени от действащото законодателство.
            </p>
            <p className="leading-relaxed mb-4">
              6.2. Съдържанието, качено от Потребителите, си остава тяхна собственост. Доставчикът не придобива права върху това Съдържание, освен правото да го съхранява и обработва за целите на услугите.
            </p>
          </div>
          {/* 7. Такси и плащания */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              7. Такси и плащания
            </h2>
            <p className="leading-relaxed mb-4">
              7.1. Използването на физическите карти EvoCard може да бъде обвързано с еднократна или периодична такса, а определени функционалности (като допълнително пространство в облака, премиум ефекти и др.) може да са платени.
            </p>
            <p className="leading-relaxed mb-4">
              7.2. Информация за всички такси, методи на плащане и срокове се публикува на нашия уебсайт или в мобилното приложение. С извършване на плащане, Вие се съгласявате с обявените условия и цени.
            </p>
          </div>
          {/* 8. Ограничение на отговорността */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              8. Ограничение на отговорността
            </h2>
            <p className="leading-relaxed mb-4">
              8.1. EvoCard полага усилия за поддържане на услугите си в изправно техническо състояние и осигурява висока степен на сигурност на данните. Въпреки това, Доставчикът не носи отговорност за загуба на данни, прекъсване на услугите, неоторизиран достъп или други форсмажорни обстоятелства, които са извън неговия контрол.
            </p>
            <p className="leading-relaxed mb-4">
              8.2. Доставчикът не носи отговорност за законността, качеството, надеждността или годността на Съдържанието, качено от Потребителите.
            </p>
            <p className="leading-relaxed mb-4">
              8.3. EvoCard не носи отговорност за качени нецензурни, незаконни или друг вид неподходящи клипове, включително за евентуални претенции и щети, произтичащи от такова Съдържание. Изключителна отговорност за съдържанието на видеоклиповете (и други форми на мултимедия) носят самите Потребители, които са ги качили и споделили чрез услугите на EvoCard.
            </p>
          </div>
          {/* 9. Промени в Условията */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              9. Промени в Условията
            </h2>
            <p className="leading-relaxed mb-4">
              9.1. EvoCard си запазва правото да променя настоящите Условия по всяко време, като уведомява Потребителите по подходящ начин (например чрез публикуване на сайта или чрез съобщение в приложението).
            </p>
            <p className="leading-relaxed mb-4">
              9.2. Продължаването на използването на услугите след влизане в сила на промените се счита за съгласие с новите условия. Ако не приемете промените, Вашият достъп до услугите може да бъде преустановен.
            </p>
          </div>
          {/* 10. Прекратяване */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              10. Прекратяване
            </h2>
            <p className="leading-relaxed mb-4">
              10.1. Потребителят може да прекрати използването на услугите на EvoCard по всяко време, без да посочва причина. Достатъчно е да спре да използва приложението или да се отпише от профила си (ако има такъв).
            </p>
            <p className="leading-relaxed mb-4">
              10.2. EvoCard може да прекрати достъпа на Потребител, ако има съмнения за нарушение на настоящите Условия или на действащото законодателство, или при злоупотреба със системата.
            </p>
          </div>
          {/* 11. Приложимо право и разрешаване на спорове */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              11. Приложимо право и разрешаване на спорове
            </h2>
            <p className="leading-relaxed mb-4">
              11.1. Настоящите Условия се уреждат от действащото българско законодателство (или друго приложимо, в зависимост от седалището на Доставчика).
            </p>
            <p className="leading-relaxed mb-4">
              11.2. Всички спорове, възникнали от или свързани с тези Условия, се решават по пътя на преговори. Ако не бъде постигнато съгласие, спорът се отнася към компетентния съд съобразно действащото законодателство.
            </p>
          </div>
          {/* 12. Контакти */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-red-700 mb-3">
              12. Контакти
            </h2>
            <p className="leading-relaxed mb-4">
              При въпроси, жалби или искания, свързани с услугите на EvoCard, може да се свържете с нас на:
            </p>
            <ul className="list-disc list-inside pl-4 space-y-2">
              <li>Ел. поща: support@evocard.com</li>
              <li>Телефон: +359 123 456 789</li>
              <li>Адрес: София, България</li>
            </ul>
          </div>
          <hr className="my-6" />
          <p className="text-sm text-gray-500">
            С продължаване на използването на услугите на EvoCard, Вие декларирате, че сте прочели, разбрали и се съгласявате с настоящите Общи условия.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}